/**
 * Returns array of values that occurred more than once in provided array
 * @example
 * [1, 2, 3, 1, 1, 2, 2] -> [1, 2]
 * [1, 2, 3] -> []
 * @param {Array<T>} list Array of values to be checked
 * @returns {Array<T>}
 */
const getDuplicatedValues = list => {
  const notUnique = (val, index, arr) => arr.indexOf(val) !== index

  const unique = (val, index, arr) => arr.indexOf(val) === index

  return list
    .filter(notUnique) //filter out duplicated values
    .filter(unique) // return only unique instances of duplicated values
}

const isNotDefined = val => val === null || val === undefined || val === ''

/** Validates "Add code" form. Throws an error with descriptive message if form is not valid
 * @param {string} formData.campaign_id - ID of the campaign. Required.
 * @param {string} formData.city_id - ID of the city. Required.
 * @param {string} formData.flyers_quantity Quantity of each provided code to be added. Required.
 * Should be positive number after parsing
 * @param {string} formData.flyer_codes Comma-separated list of codes. Codes should be unique. Required.
 */
export default ({
  campaignId,
  cityId,
  quantity: flyersQuantity,
  codes: flyerCodes,
}) => {
  if (isNotDefined(campaignId)) {
    throw new Error("There's no campaign id.")
  }
  if (isNotDefined(cityId)) {
    throw new Error("There's no city id.")
  }

  if (isNotDefined(flyersQuantity)) {
    throw new Error("There's no flyers quantity.")
  }

  if (isNaN(flyersQuantity)) {
    throw new Error('Flyers quantity is not a valid number.')
  }

  if (parseInt(flyersQuantity, 10) <= 0) {
    throw new Error('Flyers quantity cannot be negative or 0.')
  }

  const flyerCodesList = flyerCodes.split(/[,\s]+/g).filter(code => code)

  if (flyerCodesList.length <= 0) {
    throw new Error('There are no flyers codes.')
  }

  const duplicatedValues = getDuplicatedValues(flyerCodesList)
  if (duplicatedValues.length > 0) {
    throw new Error(
      `Following code(s) are duplicated: ${duplicatedValues.join(
        ', ',
      )}. Please provide a list of unique codes`,
    )
  }

  return true
}



// WEBPACK FOOTER //
// ./src/Utils/Validators/addCodeForm.js